import React, { Component } from 'react'
import axios from 'axios'
import Modal from 'react-modal'

import firebase from '../Configs/firebase'
import Config from '../Configs/staticConfig'
import SearchUser from './SearchUser'

import DroneLayer from '../Models/DroneLayer';

class RBACModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isPublic : true,
            team : null,
            isAddingUser : false,
            isLoading : true
        }

        this.handleToggled = this.handleToggled.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleAddNewUser = this.handleAddNewUser.bind(this)
        this.addNewUserToTeam = this.addNewUserToTeam.bind(this)
        this.handleChangePermission = this.handleChangePermission.bind(this)
        this.handleDeleteUser = this.handleDeleteUser.bind(this)
        this.setTeam = this.setTeam.bind(this)
        this.drone = null
    }

    componentDidMount(){
        const { selectedFile } = this.props
        this.setTeam(selectedFile)
    }

    setTeam( selectedFile ){
        firebase.firestore().collection('drones').doc(selectedFile.link.split('drone/')[1]).get()
        .then(snapshot=>{
            if( this.drone === null ) this.drone = new DroneLayer.initBySnapshot(snapshot)
            if( this.drone.rbac !== undefined ){
                var body = {
                    uid:Object.keys(this.drone.rbac)
                }
                return axios.post(Config.getDisplaynameAndPhotoRequestURL(),body) 
            }
            return null
        })
        .then(res=>{
            if(res === null) return this.setState({isLoading:false})
            this.setState({
                isPublic:this.drone.isPublic,
                team:res.data,
                isLoading: false
            })
        })
    }

    handleToggled(e){
        const { selectedFile } = this.props
        if(e.currentTarget.value === 'public') {
            this.setState({isPublic:true})
            this.drone = this.drone.setPublic(true)
        }
        else if (e.currentTarget.value === 'private'){
            this.drone = this.drone.setPublic(false)
            this.setTeam(selectedFile)
            this.setState({isPublic:false})
        } 
    }

    handleChangePermission(e,key){
        e.preventDefault()
        this.drone = this.drone.setRole(key,e.target.value)
        this.setState({team:this.state.team})
    }

    handleDeleteUser(e,key){
        e.preventDefault()
        const { team } = this.state
        this.drone = this.drone.removeUser(key)
        delete team[key]
        this.setState({team:this.state.team})
    }

    handleSave(){
        const { selectedFile, dismissModal } = this.props
        const { isPublic } = this.state
        firebase.firestore().collection('drones').doc(selectedFile.link.split('drone/')[1])
        .update({
            is_public:isPublic,
            rbac:this.drone.rbac
        })

        dismissModal()
    }

    handleAddNewUser(){
        this.setState({isAddingUser:true})
    }

    addNewUserToTeam(newUser){
        const { team } = this.state
        if(newUser !== undefined) {
            team[newUser._id]={
                displayName:newUser._source.name,
                photoURL : ""
            }
            this.drone = this.drone.setRole(newUser._id,"writer")
            this.setState({
                team:team,
                isAddingUser:false
            })
        }
    }

    render(){
        const { isOpen, user } = this.props
        const { isPublic, team, isAddingUser, isLoading } = this.state
        let rbacContent = null
        let newUser = null
        let content =   <span className="MapsDetailsLoadingIcon icon is-medium">
                            <i className="fas fa-spinner fa-pulse fa-2x"></i>
                        </span>

        if ( !isLoading ){
            content =   <div className="modal-content modal-alert">
                            <div className="UploadProgressContentBox box">
                                <div className="content">
                                    <h1>จัดการสิทธิ์</h1>
                                    <input type="radio" name="permission" value="public" onChange={this.handleToggled} checked={isPublic} />
                                    <label> สาธารณะ</label><br/>
                                    <input type="radio" name="permission" value="private" onChange={this.handleToggled} checked={!isPublic}/>
                                    <label> ส่วนตัว</label><br/>
                                    {rbacContent}
                                    {newUser}
                                </div>
                                <div>
                                    <button onClick={this.handleSave}>บันทึก</button>
                                    <button onClick={this.props.dismissModal}>ยกเลิก</button>
                                </div>
                            </div>
                        </div>
        }
        
        if ( !isPublic ){
            let teamContent = null
            newUser =  <button onClick={this.handleAddNewUser}>เพิ่ม</button>
            if ( this.drone.rbac !== undefined ){
                teamContent= Object.keys(team).map((key,index)=>{
                    if (key === user.uid) return null
                    return(
                        <div key={key}>
                            <label> ชื่อ : </label>
                            <input type="text" value={team[key].displayName} readOnly="readonly" size="50"></input>
                            <label> ตำแหน่ง : </label>
                            <select value={this.drone.rbac[key]} onChange={(e)=>this.handleChangePermission(e,key)}>
                                <option value="writer" >ผู้เขียน</option>
                                <option value="reader" >ผู้อ่าน</option>
                            </select>
                            <button onClick={(e)=>this.handleDeleteUser(e,key)}>ลบ</button>
                        </div>
                    )               
                })
            }
            if ( isAddingUser ){
                newUser =   <div>
                                <hr/>
                                <label> ค้นหาด้วย ชื่อ อีเมลล์ หรือ เบอร์โทรศัพท์ </label><br/>
                                <SearchUser addNewUserToTeam={this.addNewUserToTeam}></SearchUser>
                            </div>
            }
            rbacContent =   <div>
                                <hr/>
                                <label> ชื่อ : </label>
                                <input type="text" value={user.name} readOnly="readonly" size="50"></input>
                                <label> ตำแหน่ง : </label>
                                <select disabled>
                                    <option value="owner">เจ้าของ</option>
                                    <option value="writer">ผู้เขียน</option>
                                    <option value="reader">ผู้อ่าน</option>
                                </select>
                                <hr/>
                                {teamContent}
                            </div>
                            
            content =   <div className="modal-content modal-alert">
                            <div className="UploadProgressContentBox box">
                                <div className="content">
                                    <h1>จัดการสิทธิ์</h1>
                                    <input type="radio" name="permission" value="public" onChange={this.handleToggled} checked={isPublic} />
                                    <label> สาธารณะ</label><br/>
                                    <input type="radio" name="permission" value="private" onChange={this.handleToggled} checked={!isPublic}/>
                                    <label> ส่วนตัว</label><br/>
                                    {rbacContent}
                                    {newUser}
                                </div>
                                <div>
                                    <button onClick={this.handleSave}>บันทึก</button>
                                    <button onClick={this.props.dismissModal}>ยกเลิก</button>
                                </div>
                            </div>
                        </div>
        }
        
        return(
            <Modal
                isOpen={isOpen} 
                contentLabel="จัดการสิทธิ์" 
                onRequestClose={this.props.handleClosePermissionModal} 
                className="modal is-active"
                overlayClassName="modal-overlay"
                htmlOpenClassName="ReactModal__Html--open" >
                <div className="modal-background"></div>
                {content}
            </Modal>
        )
    }
}

export default RBACModal




// WEBPACK FOOTER //
// ./src/Components/RBACModal.js